import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/ditto';
import apiClient from '../helpers/apiClient';
import config from 'config';

let _client = null;
function* addNewDitto({ dittoId }) {
    const successAction = { type: actionTypes.ADD_DITTO_SUCCESS };
    const errorAction = { type: actionTypes.ADD_DITTO_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.post(config.apiPath.dittoProfile + dittoId));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}


function* saveDitto({ dittoId }) {
    const successAction = { type: actionTypes.SAVE_UPDATE_DITTO_SUCCESS };
    const errorAction = { type: actionTypes.SAVE_UPDATE_DITTO_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => client.post(config.apiPath.saveUpdateDitto + dittoId));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runDittoCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.ADD_DITTO_LOAD, addNewDitto),
        takeLatest(actionTypes.SAVE_UPDATE_DITTO_LOAD, saveDitto),
    ]);
}
